import type { ReactNode } from "react";

export interface MainProps {
    children: ReactNode;
}

/** 主内容容器，统一保留旧 Vue 页面内容区的滚动和内边距入口。 */
export function Main({ children }: MainProps) {
    return <main className="layout-main-container">{children}</main>;
}

export default Main;
